'use strict';
import * as $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024$002dProvided from "./app.data.-Accepted-Request-Provided-E-P-S-Code$-Provided.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8(evaluator$21) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$8__f_evaluator$1 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$8__f_evaluator$1 = evaluator$21;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$8() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$8__f_evaluator$1.apply__O();
  return ((v instanceof $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024$002dProvided.$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$8, "app.api.DrugRequestsAcceptedListItem$$anon$8", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$8 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$8.js.map
